__turbopack_context__.v({
  "form": "RegistrationLoading-module-scss-module__hyJFfG__form",
  "image": "RegistrationLoading-module-scss-module__hyJFfG__image",
  "line": "RegistrationLoading-module-scss-module__hyJFfG__line",
  "skeleton-lines-layout": "RegistrationLoading-module-scss-module__hyJFfG__skeleton-lines-layout",
  "skeleton-loading": "RegistrationLoading-module-scss-module__hyJFfG__skeleton-loading",
});
